/** Initial number of genes shown when a disease is expanded */
export const INITIAL_GENE_LIMIT = 20;
/** Batch size for "Show next 20" */
export const GENE_BATCH_SIZE = 20;
/** Show warning when graph exceeds this many nodes */
export const NODE_LIMIT_WARNING = 100;
/** Hide labels when more than this many nodes are visible */
export const LABEL_HIDE_THRESHOLD = 80;
/** If a disease has more than this many genes, group under "Other genes (N)" */
export const OTHER_GENES_THRESHOLD = 200;
